export function exit() {
    document.addEventListener("DOMContentLoaded", function() {

    function handleCloseButtonClick() {
        const exitPopup = document.querySelector('.exit-popup'); 
        const body = document.querySelector('body');
    
        if (exitPopup) {
            exitPopup.classList.add('visible');
            updateRightDivHeight();
            console.log('.exit-popup is now visible.');
        } else {
            console.error('.exit-popup not found.');
        }
    
        body.classList.add('popup-open');
        console.log('Body now has the class "popup-open".');
    }

    function closeClick() {
        const exitPopup = document.querySelector('.exit-popup'); 
        const body = document.querySelector('body');
    
        if (exitPopup) {
            exitPopup.classList.remove('visible');
            body.classList.remove('popup-open');
        } else {
            console.error('.exit-popup not found.');
        }
    
        console.log('Button inside .exit-popup clicked.');
    }
    
    function handleCopyInputClick() {
        const saveLink = document.querySelector('.gform_save_link'); 
        const exitPopup = document.querySelector('.exit-popup'); 

        if (saveLink) {
            saveLink.click();
            exitPopup.classList.add('saveandcontinue');
            console.log('Simulated click on .gform_save_link.');
        } else {
            console.error('.gform_save_link not found.');
        }
    }

    function updateRightDivHeight() {
        const rightDiv = document.querySelector('.right');
        if (!rightDiv) {
            return;
        }
        const rightDivHeight = rightDiv.scrollHeight; 
        rightDiv.style.height = `${rightDivHeight}px`;
    }

    // Function to handle when .form_saved_message appears
    function handleFormSavedMessage() {
        const exitPopup = document.querySelector('.exit-popup');
        const formSavedMessage = document.querySelector('.form_saved_message');
        const body = document.querySelector('body');
        
        if (formSavedMessage && exitPopup) {
            // Remove any existing .form-saved-content before adding new one
            const existingFormSavedContent = exitPopup.querySelector('.form-saved-content');
            if (existingFormSavedContent) {
                existingFormSavedContent.remove();
                console.log('Removed existing .form-saved-content from .exit-popup.');
            }
    
            // Add 'saved' class to exit popup
            exitPopup.classList.add('saved');
            body.classList.add('saved');
            console.log('.exit-popup now has the class "saved".');
            
            // Copy the content of .form_saved_message into the exit popup
            exitPopup.innerHTML += `<div class="form-saved-content">${formSavedMessage.innerHTML}</div>`;
            console.log('Copied content from .form_saved_message to .exit-popup.');
        } else {
            console.error('Either .form_saved_message or .exit-popup not found.');
        }
    }
    

    // Function to handle when .form_saved_message_sent appears
    function handleFormSavedMessageSent() {
        const exitPopup = document.querySelector('.exit-popup');
        const formSavedMessageSent = document.querySelector('.form_saved_message_sent');
        
        if (formSavedMessageSent && exitPopup) {
            // Add 'success' class to exit popup
            exitPopup.classList.add('success');
            console.log('.exit-popup now has the class "success".');
            
            // Copy the content of .form_saved_message_sent into the exit popup without replacing the existing content
            exitPopup.innerHTML += `<div class="form-sent-content">${formSavedMessageSent.innerHTML}</div>`;
            console.log('Copied content from .form_saved_message_sent to .exit-popup.');
        } else {
            console.error('Either .form_saved_message_sent or .exit-popup not found.');
        }
    }

    // Use MutationObserver to detect changes in .question-form
    const questionForm = document.querySelector('.question-form');
    if (questionForm) {
        const observer = new MutationObserver(function(mutations) {
            mutations.forEach(function(mutation) {
                mutation.addedNodes.forEach(function(node) {
                    if (node.nodeType === 1) {  // Check if it's an element node
                        if (node.classList.contains('form_saved_message')) {
                            console.log('.form_saved_message detected in MutationObserver.');
                            handleFormSavedMessage();
                        }
                        if (node.classList.contains('form_saved_message_sent')) {
                            console.log('.form_saved_message_sent detected in MutationObserver.');
                            handleFormSavedMessageSent();
                        }
                    }
                });
            });
        });

        // Configure the observer to watch for child nodes being added
        observer.observe(questionForm, { childList: true, subtree: true });
        console.log('MutationObserver is now watching .question-form for added nodes.');
    } else {
        console.error('.question-form not found.');
    }
    
    const closeButton = document.querySelector('.close-button'); 
    if (closeButton) {
        closeButton.addEventListener('click', function() {
            console.log('Close button clicked.');
            handleCloseButtonClick(); 
        });
    } else {
        console.error('.close-button not found.');
    }
    function handleLinkClick(event) {
        const clickedElement = event.target;
    
        if (clickedElement.matches('a.button.resume_form_link_wrapper') || 
            clickedElement.closest('a.button.resume_form_link_wrapper')) {
            console.log('Link clicked');
            clickedElement.classList.add('copied');
        }
    }
    document.querySelector('.exit-popup').addEventListener('click', handleLinkClick);
    
    document.addEventListener('click', function(event) {
        if (event.target.closest('.exit-popup #resume')) {
            console.log('Button inside .exit-popup clicked.');
            closeClick(); 
        }
        if (event.target.id === 'copy' && event.target.closest('.exit-popup')) {
            console.log('Input with id "copy" clicked.');
            handleCopyInputClick(); 
        }
    });
    });
}
